import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const entityQuery = createApi({
  baseQuery,
  reducerPath: "entityQueries",
  endpoints: (builder) => ({
    getAllEntities: builder.query<any, any>({
      query: () => ({
        url: `${formatString(endPoints.entity.getAll)}`,
        method: "GET",
      }),
    }),
    getEntityDetails: builder.query<any, any>({
      query: ({ table_name }) => ({
        url: `${formatString(endPoints.entity.selectEntity, {
          key: urlKeys.table_name,
          value: table_name,
        })}`,
        method: "GET",
      }),
    }),
    createEntity: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.entity.create)}`,
        method: "POST",
        body: data,
      }),
    }),
    udpateEntity: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.entity.update)}`,
        method: "PUT",
        body: data,
      }),
    }),
    createAlembicRevision: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.entity.createAlembicRevision)}`,
        method: "POST",
        body: data,
      }),
    }),
    upgradeAlembicRevision: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.entity.upgradeAlembicRevision)}`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetAllEntitiesQuery,
  useLazyGetEntityDetailsQuery,
  useCreateEntityMutation,
  useCreateAlembicRevisionMutation,
  useUpgradeAlembicRevisionMutation,
  useUdpateEntityMutation,
} = entityQuery;
